<template>
  <mcs-sheet
    class="grey"
    dense
    small-radius
  >
    <v-row dense>
      <v-col
        v-for="(item, i) in items"
        :key="i"
        :cols="12 / items.length"
      >
        <mcs-btn
          block
          :color="value == item.id ? 'black' : 'white'"
          @click="$emit('input', item.id)"
        >
          {{ item.title }}
        </mcs-btn>
      </v-col>
    </v-row>
  </mcs-sheet>
</template>

<script>
export default {
  props: { items: { type: Array, default: () => {} }, value: { type: String, default: '' } }
};
</script>
